import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'
import { milestoneDotsPlugin } from '../charts/milestone_dots'

export default class extends Controller {
  static targets = ['chart', 'metric']
  static values = { daily: Array, levels: Array }

  connect () {
    this.chart = new Chart(this.chartTarget, {
      type: 'bar',
      data: { labels: this.dailyValue.map(row => row.date), datasets: [] },
      plugins: [milestoneDotsPlugin(this.dailyValue, this.levelsValue)],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        // Leave room for a stack of all six award colors above the tallest bar.
        layout: { padding: { top: 64, left: 4, right: 4 } },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              afterBody: (items) => {
                const levels = this.dailyValue[items[0]?.dataIndex]?.milestone_levels || []
                return levels.map(level => `${level[0].toUpperCase()}${level.slice(1)} milestone awarded`)
              }
            }
          }
        },
        scales: {
          x: { grid: { display: false }, ticks: { maxTicksLimit: 12 } },
          y: { beginAtZero: true, ticks: { precision: 0 } }
        }
      }
    })
    this.update()
  }

  disconnect () {
    this.chart?.destroy()
  }

  update () {
    const key = this.metricTarget.value
    const label = this.metricTarget.selectedOptions[0].text
    this.chart.data.datasets = [{
      label,
      data: this.dailyValue.map(row => row[key]),
      backgroundColor: '#0f766e',
      borderRadius: 4
    }]
    this.chart.options.scales.y.ticks.precision = key === 'minutes' ? 1 : 0
    this.chart.update()
  }
}
